// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"290":"209f8f4fc081c236","816":"887cb95d74ed5e4f"}[chunkId] + ".js";
};